import { TreesloGridColumn } from "../treeslo-grid.model";

/** Applies a persisted fieldName order on top of the dev-defined column list. */
export function applyTreesloGridColumnOrder<ItemModel>(
  columns: TreesloGridColumn<ItemModel>[],
  savedOrder?: string[] | null,
): TreesloGridColumn<ItemModel>[] {
  if (!savedOrder?.length) {
    return [...columns];
  }

  const columnByField = new Map(
    columns.map((column) => [column.fieldName, column]),
  );
  const ordered: TreesloGridColumn<ItemModel>[] = [];
  const used = new Set<string>();

  for (const fieldName of savedOrder) {
    const column = columnByField.get(fieldName);
    if (column) {
      ordered.push(column);
      used.add(fieldName);
    }
  }

  for (const column of columns) {
    if (!used.has(column.fieldName)) {
      ordered.push(column);
    }
  }

  return ordered;
}

/** Whether a column participates in drag-and-drop reorder (default: true). */
export function isTreesloGridColumnDraggable<ItemModel>(
  column: TreesloGridColumn<ItemModel>,
): boolean {
  return column.reorderable !== false;
}
